const checkAuth = (navigate) => {
  const rawCandidateInfo = sessionStorage.getItem("candidate_details");
  const candidateInfoExists = !!rawCandidateInfo;

  if (!candidateInfoExists) {
    navigate("/login");
    return false;
  }
  return true;
};

export default checkAuth;
